import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Heart } from 'lucide-react';

/**
 * On-brand floating donate button. Routes visitors to the internal
 * "Sponsor a Lesson" page, which now hosts the Givebutter donation flow
 * plus the Hope Floats Foundation partnership story.
 */
export default function DonateButton() {
  useEffect(() => {
    // No third-party script needed — donation happens on Givebutter's own page.
  }, []);

  return (
    <Link
      to="/sponsor-a-lesson"
      data-testid="donate-button"
      className="ls-donate-btn group"
      aria-label="Sponsor a Lesson — Support Hope Floats Foundation"
    >
      <span className="ls-donate-btn__pulse" aria-hidden="true" />
      <span className="ls-donate-btn__icon">
        <Heart className="w-4 h-4" strokeWidth={2.5} />
      </span>
      <span className="ls-donate-btn__text">
        <span className="ls-donate-btn__eyebrow">Sponsor</span>
        <span className="ls-donate-btn__title">a Lesson</span>
      </span>
    </Link>
  );
}
